export const actions = {
  async getHome(state) {
    const res = await this.$axios.get('/pages/home')
    return res.data
  },
}
